import axios from 'axios'
import { useSelector } from 'react-redux'
import { setItem } from '../reducers/ItemSlice'
import { toggleLoaded } from '../reducers/LoadedSlice'
import {
     DATASET_1_REQUEST,
     DATASET_1_SUCCESS ,
     DATASET_1_FAIL,
    

} from '../constants/dataConstants'


export const getData = (source, idx) => async (dispatch, getState) => {
    
    try {
         
        dispatch({
            type: `DATASET_${idx+1}_REQUEST`
        })
       
        // const {
        //     userLogin: {userInfo},
        // } = getState()

        // const {
        //     sources: {value},
        // } = getState()
        


        // const config = {
        //     headers: {
        //         'Content-type': 'application/json',
        //         Authorization: `Bearer ${userInfo.token}`
        //     }
        // }
        
   

        const { data } = await axios.get(
            // `/api/${source}`,
            source
            // config
        )
        if (idx==0){
        const param = "ירושלים"
        const tmpData = data
        const hotels = tmpData[param].map(d => d.name)
        const idxs = tmpData[param].map(d => d.idx)
        
        dispatch(setItem({
            type: "hotel", 
            names:[],
            data: [],
            idxs:idxs
        }))
    }
        
        dispatch({
            type: `DATASET_${idx+1}_SUCCESS`,
            payload: data,
            idx:idx 
        })
        


    } catch (error) {
        console.log(error)
     
        dispatch({ 
            
            type:  `DATASET_${idx+1}_FAIL`,
            payload: error.response && error.response.data.detail
                ? error.response.data.detail
                : error.message,     
        })  
    }
} 
